export class Declaration {
    public completeAndCorrectInformation: boolean;
    public haveReadPrivacyStatement: boolean;
    public consentToDiscloseInformation: boolean;
    public authoriseToObtainFurtherInformation: boolean;
    public consentToAudit: boolean;
    public abideMonashPolicy: boolean;
    public agreeToDeclaration: boolean;
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/main/client/app/shared/model/Declaration.ts